import { Box, Stack } from '@mui/material';

import { pageLayoutChildrenBoxSx } from 'domains/core/components/PageLayout';
import SettingsHeader from 'domains/core/components/SettingsHeader';

import SettingsPageHeader from './SettingsPageHeader';

export type Props = {
    header: React.ReactNode;
    headerIcon: React.ReactNode;
    headerAction?: React.ReactNode;
    headerOthers?: React.ReactNode;
    children?: React.ReactNode;
    /**
     * Grey “settings” label in the top margin above the title row (does not shift the header).
     * Set false for nested tools (e.g. role builder).
     */
    showSettingsSubheader?: boolean;
};

/**
 * Settings-area shell: optional {@link SettingsHeader} in the top margin, then the same first row as
 * {@link PageLayout} ({@link SettingsPageHeader} + optional `headerAction`), then children.
 */
const SettingsPageLayout = ({
    header,
    headerIcon,
    headerAction,
    headerOthers,
    children,
    showSettingsSubheader = true,
}: Props) => {
    const titleRow = (
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <SettingsPageHeader icon={headerIcon} header={header} headerOthers={headerOthers} />
            <Stack justifyContent="center" alignItems="center" flexShrink={0}>
                {headerAction}
            </Stack>
        </Stack>
    );

    return (
        <Stack width="100%" height="100%" minHeight={0} mt={8} rowGap={8}>
            {showSettingsSubheader ? (
                <Box sx={{ position: 'relative', width: '100%' }}>
                    <Box
                        sx={(theme) => ({
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            transform: `translateY(calc(-100% - ${theme.spacing(0.5)}))`,
                        })}
                    >
                        <SettingsHeader />
                    </Box>
                    {titleRow}
                </Box>
            ) : (
                titleRow
            )}
            <Box sx={pageLayoutChildrenBoxSx}>{children}</Box>
        </Stack>
    );
};

export default SettingsPageLayout;
